<template>
  <div class="fip-detail">
    <div class="informations">
      <div class="left-informations">
        <fip-informations :item="item" />

        <fip-mentions :item="item" />

        <div>
          <participants-list
            v-if="!!artists"
            :artists="artists"
            class="infos-artists"
            data-wptv="fip-artists" />
        </div>

        <div class="resume">
          <p
            v-if="item.synopsis"
            class="fip-synopsis"
            data-wptv="fip-synopsis">
            {{ item.synopsis }}
          </p>
        </div>
      </div>

      <div class="right-informations">
        <rating
          v-if="showRating"
          :item="item" />

        <fip-user-informations
          :item="item"
          :invert="true" />
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantsList from '../../participantsList/ParticipantsList.vue'
import FipMentions from '../../fipMentions/FipMentions.vue'
import Rating from '../../rating/Rating'
import { mapGetters } from 'vuex'
import _get from 'lodash/get'
import FipUserInformations from '../../fipUserInformations/FipUserInformations'
import FipInformations from '../../fipInformations/FipInformations'

export default {
  name: 'FipDetail',
  components: {
    FipUserInformations,
    ParticipantsList,
    Rating,
    FipMentions,
    FipInformations
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      terminalModel: 'terminals/getTerminalModel'
    }),
    artists () {
      const artists = {}

      if (this.item.directors && this.item.directors.length > 0) {
        artists.DIR = this.item.directors
      }
      if (this.item.actors && this.item.actors.length > 0) {
        artists.ACT = this.item.actors
      }

      if (this.item.stageDirectors && this.item.stageDirectors.length > 0) {
        artists.MES = this.item.stageDirectors
      }

      if (this.item.authors && this.item.authors.length > 0) {
        artists.AUT = this.item.authors
      }

      if (this.item.presenters && this.item.presenters.length > 0) {
        artists.PRE = this.item.presenters
      }
      if (this.item.producers && this.item.producers.length > 0) {
        artists.PRO = this.item.producers
      }

      if (this.item.choregraphs && this.item.choregraphs.length > 0) {
        artists.CHO = this.item.choregraphs
      }
      return artists
    },
    showRating () {
      return !!(_get(this.item, 'allocineRatings.user') || _get(this.item, 'allocineRatings.press'))
    }
  }
}
</script>

<style lang="scss" scoped>
  .fip-detail {
    color: $black;
    font-size: 16px;
    line-height: 28px;

    h1, h2, h3, h4, h5 {
      font-size: inherit;
      margin: 0;
    }

    .informations {
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;
      @include mediaQueries('flex-direction', (large: row));

      .left-informations {
        flex: 1;
        max-width: 800px;

        .infos-artists {
          font-weight: bold;
          line-height: 1.16667;
        }
        .vod-availability {
          margin-bottom: 18px;
        }
      }

      .right-informations {
        @include mediaQueries('margin-left', (large: 50px));
      }
    }

    .user-information{
      margin-top: 20px;
    }

    .language {
      padding: 4px;
    }

    .background-icon {
      margin-right: 20px;
      display: inline-block;

      > div, > span {
        background-color: #DDDDDD;
        border-radius: 15px;
      }
    }
  }
</style>
